module.exports = __webpack_public_path__ + "img/m-question.20166689.png";